import React from 'react'
import { useTranslation } from "react-i18next";
import empty from '../../assets/images/empty.png'
const BoxEmpty = ({title}) => {
   const { t } = useTranslation();

  return (
    <div className='flex justify-center '>
      <div className='flex flex-col items-center md:w-[50%] w-[85%] my-5'>
              <img 
                src={empty}
                className='mb-4'
              />
        <p className="text-center text-gray-500">{t(`${title}`)}</p>
      </div>   
    </div>
    
  )
}

export default BoxEmpty
